module.exports = __webpack_public_path__ + "static/img/6.25c2854.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/sp/6.png
// module id = YWPe
// module chunks = 0